export default "/images/vendor/flag-icon-css/flags/1x1/io.svg?77f4eddb484b8f32d38a5b970c10592b";